import { render, staticRenderFns } from "./record-list.vue?vue&type=template&id=6b7af09c&scoped=true&"
import script from "./record-list.vue?vue&type=script&setup=true&lang=ts&"
export * from "./record-list.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./record-list.vue?vue&type=style&index=0&id=6b7af09c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b7af09c",
  null
  
)

/* custom blocks */
import block0 from "./record-list.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports